{
  "version": 1,
  "asset_id": "20afc60c-43ed-43e8-b1e9-c7f365ffb74d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/20afc60c-43ed-43e8-b1e9-c7f365ffb74d/workspace-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/20afc60c-43ed-43e8-b1e9-c7f365ffb74d/workspace-640.avif",
  "original_filename": "workspace-640.avif",
  "size": 13324,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:05Z"
}
